import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeInternalURL } from './ActivityRouter';

const NAME = 'My Favorite Hobby'
export const FAVORITE_HOBBY_ROUTE = 'favorite-hobby'
export const favoriteHobbyLink = () => {return (<NavLink to={makeInternalURL(FAVORITE_HOBBY_ROUTE)}>{NAME}</NavLink>)}
export const favoriteHobby = () => {
	return (
	
<div>
<br />
<h4>{NAME}</h4>
<h5>Summary: Create a HTML page describing your favorite hobby</h5>
<h5>Prerequisites: Windows 10 or MacOS, VS Code, HTML, and CSS</h5>
			
<p>The My Favorite Hobby project is a project where you will create a web page using HTML5 and CSS that highlights your 
favorite hobby. For example, you may find a passion around:</p>
<ul style={{listStyleType:'square'}}>
	<li>Cooking</li>
    <li>Photography</li>
    <li>Travel</li>
	<li>Sports</li>
	<li>Music</li>
    <li>Or just about anything else...</li>
</ul>

<em>Requirement 1</em>
<p>Create an aesthetically pleasing HTML-based web page named “my-favorite-hobby.html” which tells us something about 
your hobby, why you find it interesting, your proudest hobby related accomplishment, and maybe how someone else might 
get started with this hobby.</p>
 	
<em>Requirement 2</em>
<p>Your web page should make use of the following elements in non-trivial ways. In other words, they need to serve a 
purpose on the page.</p>
<ol>
    <li>Images</li>
    <li>Lists</li>
	<li>Tables</li>
	<li>Hyperlinks to an external page</li>
	<li>Hyperlinks within a page</li>
</ol>
 	
<em>Requirement 3</em>
<p>You will need to create an external CSS style sheet named “my-favorite-hobby.css” that will style your HTML page. 
The style sheet needs to be appropriately linked to your HTML page. You must make use of the hover pseudoclass. Also, 
you must make use of at least one of the following additional properties.</p>
<ol>
    <li>Transition</li>
    <li>Animation</li>
	<li>Transform</li>
</ol>

<em>Requirement 4: </em>
<p>Test and validate your web page:</p>
<ol>
	<li>Validate that you are following our HTML and CSS coding standards</li>
	<li>Throughout the development process you should validate your HTML utilizing the W3C HTML validator</li>
	<li>Fully test your page by viewing and testing it in both the FireFox and Chrome browsers</li>
	<li>Be careful to save and track your work as you will likely need to submit and publish the page later</li>
</ol>	
</div> )

}